import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { camelCase, startCase } from 'lodash-es';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { getBrandConfig } from '../services/branding';

export const SetPageTitle = (router: Router, titleService: Title) => (): Subscription =>
  router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe({
    next: (path) => {
      const routePath = path.url.split('/');
      let route = routePath.pop()?.split('?')[0] || '';

      if (/\d/.test(route)) {
        route = routePath[routePath.length - 1];
      }

      if (route === 'settings') {
        route = 'My Business';
      }

      const title = ['landing'].includes(route) || !route.length ? getBrandConfig().displayName : `${startCase(camelCase(route))}`;

      titleService.setTitle(`Portal - ${title}`);
    },
  });
